import { useNavigate } from 'react-router-dom';
import { useEquipo } from '../context/EquipoContext';
import { useAuth } from '../context/AuthContext';
import { useEffect, useState } from 'react';
import { getDesafiosEquipo, actualizarEstadoDesafio, getEquipos, actualizarEquipo } from '../services/api';

const MODALIDADES = [
  { id: 'futbol5',  label: 'Fútbol 5'     },
  { id: 'futbol7',  label: 'Fútbol 7'     },
  { id: 'futbol11', label: 'Fútbol 11'    },
  { id: 'padel',    label: 'Pádel'        },
  { id: 'futsal',   label: 'Futsal'       },
  { id: 'playa',    label: 'Fútbol playa' },
];

const ZONAS = [
  'Machalí', 'Rancagua', 'Sewell', 'Graneros',
  'Mostazal', 'Coinco', 'Coltauco', 'Doñihue',
  'Las Cabras', 'Peumo', 'Pichidegua', 'San Vicente',
];

const COLORES_PRESET = [
  ['#FF6B1A', '#1A6BFF'],
  ['#EF4444', '#0D1117'],
  ['#16A34A', '#FACC15'],
  ['#7C3AED', '#EC4899'],
  ['#1A6BFF', '#0D1117'],
  ['#F59E0B', '#EF4444'],
  ['#0891B2', '#16A34A'],
  ['#DC2626', '#1D4ED8'],
];

export default function Dashboard() {
  const navigate                           = useNavigate();
  const { user, token }                    = useAuth();
  const { equipo, equipos, cambiarEquipo, actualizarEquipoEnContexto, deporteActivo, cambiarDeporte } = useEquipo();

  const [desafios,        setDesafios]        = useState([]);
  const [equiposData,     setEquiposData]     = useState([]);
  const [cargando,        setCargando]        = useState(false);
  const [selectorAbierto, setSelectorAbierto] = useState(false);

  // Estado panel edición
  const [editando,        setEditando]        = useState(false);
  const [editNombre,      setEditNombre]      = useState('');
  const [editModalidades, setEditModalidades] = useState([]);
  const [editZonas,       setEditZonas]       = useState([]);
  const [editColorP,      setEditColorP]      = useState('');
  const [editColorS,      setEditColorS]      = useState('');
  const [editGrupoWsp,    setEditGrupoWsp]    = useState('');
  const [editCelular,     setEditCelular]     = useState('');
  const [editEdad,        setEditEdad]        = useState('');
  const [guardandoEdit,   setGuardandoEdit]   = useState(false);
  const [errorEdit,       setErrorEdit]       = useState('');
  const [editandoPerfil,  setEditandoPerfil]  = useState(false);
  const [formPerfil,      setFormPerfil]      = useState({ nombre: '', edad: '', celular: '' });
  const [guardandoPerfil, setGuardandoPerfil] = useState(false);

  const nombre          = equipo?.nombre          || 'Mi Equipo';
  const campoElo        = !equipo?.deporte || equipo?.deporte === 'futbol' ? 'elo' : equipo?.deporte === 'padel' ? 'elo_padel' : 'elo_tenis';
  const elo             = equipo?.[campoElo]       || 800;
  const partidos        = equipo?.partidos        || 0;
  const victorias       = equipo?.victorias       || 0;
  const empates         = equipo?.empates         || 0;
  const zona            = equipo?.zona            || 'Tu zona';
  const plan            = equipo?.plan            || 'free';
  const colorPrincipal  = equipo?.colorPrincipal  || '#FF6B1A';
  const colorSecundario = equipo?.colorSecundario || '#1A6BFF';

  const esFutbol = !deporteActivo || deporteActivo === 'futbol';

  const iniciales = nombre
    .split(' ').filter(p => p.length > 0).slice(0, 2)
    .map(p => p[0].toUpperCase()).join('');

  const winRate = partidos > 0 ? Math.round((victorias / partidos) * 100) : 0;

  useEffect(() => {
    if (!equipo?.id || !token) return;
    setCargando(true);
    Promise.all([
      getDesafiosEquipo(equipo.id, token),
      getEquipos(),
    ]).then(([desafiosRes, equiposRes]) => {
      if (Array.isArray(desafiosRes)) {
        setDesafios(desafiosRes.filter(d =>
          d.equipo_visitante_id === equipo.id && d.estado === 'pendiente'
        ));
      }
      if (Array.isArray(equiposRes)) setEquiposData(equiposRes);
    }).catch(() => {})
    .finally(() => setCargando(false));
  }, [equipo, token]);

  const abrirEdicion = async () => {
    setEditNombre(equipo?.nombre || '');
    setEditModalidades(equipo?.modalidades || []);
    setEditZonas(equipo?.zona ? equipo.zona.split(', ').map(z => z.trim()) : []);
    setEditColorP(equipo?.colorPrincipal || '#FF6B1A');
    setEditColorS(equipo?.colorSecundario || '#1A6BFF');
    setEditGrupoWsp(equipo?.grupo_wsp || '');
    setErrorEdit('');
    let celularActual = '', edadActual = '';
    try {
      const t = localStorage.getItem('turival_token');
      const res = await fetch(`${process.env.REACT_APP_API_URL || 'http://45.236.131.39:4000'}/api/usuarios/me`, {
        headers: { Authorization: `Bearer ${t}` },
      });
      const data = await res.json();
      celularActual = data?.celular || '';
      edadActual    = data?.edad    || '';
    } catch { /* si falla, quedan vacíos y se completan igual */ }
    setEditCelular(celularActual);
    setEditEdad(edadActual);
    setEditando(true);
  };

  const toggleEditModalidad = (id) => {
    setEditModalidades(prev =>
      prev.includes(id) ? prev.filter(m => m !== id) : [...prev, id]
    );
  };

  const toggleEditZona = (z) => {
    setEditZonas(prev =>
      prev.includes(z) ? prev.filter(x => x !== z) : [...prev, z]
    );
  };

  const handleGuardarEdicion = async () => {
    if (!editNombre.trim()) { setErrorEdit('El nombre es obligatorio'); return; }
    if (editModalidades.length === 0) { setErrorEdit('Selecciona al menos una modalidad'); return; }
    if (editZonas.length === 0) { setErrorEdit('Selecciona al menos una zona'); return; }
    if (!editCelular.trim()) { setErrorEdit('Tu WhatsApp es obligatorio'); return; }
    setGuardandoEdit(true); setErrorEdit('');
    try {
      const data = await actualizarEquipo(equipo.id, {
        nombre:           editNombre.trim(),
        color_principal:  editColorP,
        color_secundario: editColorS,
        zona:             editZonas.join(', '),
        modalidades:      editModalidades,
        grupo_wsp:        editGrupoWsp.trim() || null,
      }, token);
      if (data.error) { setErrorEdit(data.error); return; }

      // Guardar WhatsApp y edad personales del capitán
      const t = localStorage.getItem('turival_token');
      await fetch(`${process.env.REACT_APP_API_URL || 'http://45.236.131.39:4000'}/api/usuarios/${user?.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${t}` },
        body: JSON.stringify({
          celular: editCelular.trim(),
          edad:    editEdad ? parseInt(editEdad) : undefined,
        }),
      });

      actualizarEquipoEnContexto(data);
      setEditando(false);
    } catch {
      setErrorEdit('Error de conexión');
    } finally {
      setGuardandoEdit(false);
    }
  };

  const handleGuardarPerfil = async () => {
    if (!formPerfil.nombre.trim()) return;
    if (!formPerfil.celular.trim()) { alert('Tu WhatsApp es obligatorio'); return; }
    setGuardandoPerfil(true);
    try {
      const t = localStorage.getItem('turival_token');
      // Actualizar nombre del equipo/perfil
      await fetch(`${process.env.REACT_APP_API_URL || 'http://45.236.131.39:4000'}/api/equipos/${equipo.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${t}` },
        body: JSON.stringify({ nombre: formPerfil.nombre.trim(), zona: equipo.zona, modalidades: equipo.modalidades, color_principal: equipo.colorPrincipal, color_secundario: equipo.colorSecundario }),
      });
      // Actualizar WhatsApp y edad en usuarios
      await fetch(`${process.env.REACT_APP_API_URL || 'http://45.236.131.39:4000'}/api/usuarios/${user?.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${t}` },
        body: JSON.stringify({
          celular: formPerfil.celular.trim(),
          edad:    formPerfil.edad ? parseInt(formPerfil.edad) : undefined,
        }),
      });
      setEditandoPerfil(false);
      window.location.reload();
    } catch { alert('Error al guardar'); }
    finally { setGuardandoPerfil(false); }
  };

  const getNombreEquipo = (id) => {
    const e = equiposData.find(eq => eq.id === id);
    return e?.nombre || 'Equipo #' + id;
  };

  const handleAceptar = async (id) => {
    await actualizarEstadoDesafio(id, 'aceptado', token);
    setDesafios(prev => prev.filter(d => d.id !== id));
  };

  const handleRechazar = async (id) => {
    await actualizarEstadoDesafio(id, 'rechazado', token);
    setDesafios(prev => prev.filter(d => d.id !== id));
  };

  // Sin equipo
  if (!equipo) {
    return (
      <div style={styles.pagina}>
        {/* Selector deporte — siempre visible para poder cambiar */}
        <div style={styles.deporteSelector}>
          {[
            { id: 'futbol', label: '⚽ Fútbol' },
            { id: 'padel',  label: '🎾 Pádel'  },
            { id: 'tenis',  label: '🎾 Tenis'  },
          ].map(d => {
            const tieneEquipo = equipos.some(e =>
              d.id === 'futbol'
                ? (!e.deporte || e.deporte === 'futbol')
                : e.deporte === d.id
            );
            return (
              <div
                key={d.id}
                onClick={() => cambiarDeporte(d.id)}
                style={{
                  ...styles.deporteTab,
                  background:  deporteActivo === d.id ? '#FF6B1A' : 'rgba(255,255,255,0.06)',
                  color:       deporteActivo === d.id ? 'white'   : 'rgba(255,255,255,0.4)',
                  border:      `1.5px solid ${deporteActivo === d.id ? '#FF6B1A' : 'rgba(255,255,255,0.1)'}`,
                }}
              >
                {d.label}
                {tieneEquipo && deporteActivo !== d.id && (
                  <span style={styles.deporteDot} />
                )}
              </div>
            );
          })}
        </div>
        <div style={styles.sinEquipoCard}>
          <div style={styles.sinEquipoIcono}>{deporteActivo === "futbol" ? "⚽" : "🎾"}</div>
          <div style={styles.sinEquipoTitulo}>
            Bienvenido, {user?.nombre?.split(' ')[0]}
          </div>
          <div style={styles.sinEquipoSub}>
            {deporteActivo === 'futbol'
              ? 'Aún no tienes un equipo registrado en TuRival. Créalo en menos de 2 minutos.'
              : `Aún no tienes un perfil de ${deporteActivo === 'padel' ? 'Pádel' : 'Tenis'} en TuRival. Créalo en menos de 2 minutos.`}
          </div>
          <button
            style={styles.btnCrearEquipo}
            onClick={() => navigate('/app/crear-equipo')}
          >
            {deporteActivo === 'futbol' ? '⚡ Crear mi equipo' : '⚡ Crear mi perfil'}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.pagina}>

      {/* SELECTOR DEPORTE */}
      <div style={styles.deporteSelector}>
        {[
          { id: 'futbol', label: '⚽ Fútbol'  },
          { id: 'padel',  label: '🎾 Pádel'   },
          { id: 'tenis',  label: '🎾 Tenis'   },
        ].map(d => {
          const tieneEquipo = equipos.some(e =>
            d.id === 'futbol'
              ? (!e.deporte || e.deporte === 'futbol')
              : e.deporte === d.id
          );
          return (
            <div
              key={d.id}
              onClick={() => cambiarDeporte(d.id)}
              style={{
                ...styles.deporteTab,
                background:  deporteActivo === d.id ? '#FF6B1A' : 'rgba(255,255,255,0.06)',
                color:       deporteActivo === d.id ? 'white'   : 'rgba(255,255,255,0.4)',
                border:      `1.5px solid ${deporteActivo === d.id ? '#FF6B1A' : 'rgba(255,255,255,0.1)'}`,
              }}
            >
              {d.label}
              {tieneEquipo && deporteActivo !== d.id && (
                <span style={styles.deporteDot} />
              )}
            </div>
          );
        })}
      </div>

      {/* CARD EQUIPO */}
      <div style={styles.equipoCard}>
        <div style={styles.equipoLeft}>
          <div style={{
            ...styles.escudo,
            background: `linear-gradient(135deg, ${colorPrincipal}, ${colorSecundario})`,
          }}>
            {iniciales}
          </div>
          <div style={styles.equipoInfo}>
            <div
              style={styles.equipoNombre}
              onClick={abrirEdicion}
              title="Clic para editar"
            >
              {nombre} <span style={styles.editHint}>✏️</span>
            </div>
            <div style={styles.equipoUsuario}>👤 {user?.nombre || ''}</div>
            <div style={styles.equipoMeta}>
              📍 {zona}
              {equipo?.modalidades?.length > 0
                ? ' · ' + equipo.modalidades.map(m =>
                    m === 'futbol5' ? 'Fútbol 5' :
                    m === 'futbol7' ? 'Fútbol 7' :
                    m === 'futbol11' ? 'Fútbol 11' :
                    m === 'padel' ? 'Pádel' :
                    m === 'futsal' ? 'Futsal' : m
                  ).join(', ')
                : ''}
            </div>
            <div style={styles.planBadge}>
              {plan === 'pro' ? '⚡ Plan Pro' : plan === 'club' ? '🏆 Plan Club' : '🆓 Plan Free'}
            </div>
          </div>
        </div>

        <div style={styles.equipoDerecha}>
          <div style={styles.eloWrap}>
            <div style={styles.eloNum}>{elo}</div>
            <div style={styles.eloLabel}>ELO TuRival</div>
            <div style={styles.eloTendencia}>↑ activo</div>
          </div>
          <div style={styles.equipoBotones}>
            {esFutbol && (
              <button
                style={styles.btnOtroEquipo}
                onClick={() => navigate('/app/crear-equipo')}
              >
                + Crear otro equipo
              </button>
            )}
            {!esFutbol && (
              <>
                <button
                  style={styles.btnOtroEquipo}
                  onClick={async () => {
                    let celularActual = '';
                    try {
                      const t = localStorage.getItem('turival_token');
                      const res = await fetch(`${process.env.REACT_APP_API_URL || 'http://45.236.131.39:4000'}/api/usuarios/me`, {
                        headers: { Authorization: `Bearer ${t}` },
                      });
                      const data = await res.json();
                      celularActual = data?.celular || '';
                    } catch { /* si falla, queda vacío y se completa igual */ }
                    setFormPerfil({ nombre: nombre, edad: '', celular: celularActual });
                    setEditandoPerfil(true);
                  }}
                >
                  ✏️ Modificar perfil
                </button>
                <button
                  style={styles.btnEliminarPerfil}
                  onClick={async () => {
                    const deporteLabel = deporteActivo === 'padel' ? 'Pádel' : 'Tenis';
                    if (!window.confirm(`¿Eliminar tu perfil de ${deporteLabel} "${nombre}"? Esta acción no se puede deshacer.`)) return;
                    const t = localStorage.getItem('turival_token');
                    await fetch(`${process.env.REACT_APP_API_URL || 'http://45.236.131.39:4000'}/api/equipos/${equipo.id}`, {
                      method: 'DELETE', headers: { Authorization: `Bearer ${t}` },
                    });
                    window.location.reload();
                  }}
                >
                  🗑 Eliminar perfil
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* PANEL EDICIÓN */}
      {editando && (
        <div style={styles.editPanel}>
          <div style={styles.editPanelTitulo}>Editar equipo</div>

          {/* Nombre */}
          <div style={styles.editCampo}>
            <div style={styles.editLabel}>Nombre del equipo</div>
            <input
              style={styles.editInput}
              value={editNombre}
              onChange={e => setEditNombre(e.target.value)}
              maxLength={40}
            />
          </div>

          {/* Colores */}
          <div style={styles.editCampo}>
            <div style={styles.editLabel}>Colores</div>
            <div style={styles.coloresGrid}>
              {COLORES_PRESET.map(([c1, c2], i) => (
                <div
                  key={i}
                  onClick={() => { setEditColorP(c1); setEditColorS(c2); }}
                  style={{
                    ...styles.colorPreset,
                    background: `linear-gradient(135deg, ${c1}, ${c2})`,
                    border: editColorP === c1 && editColorS === c2
                      ? '3px solid #FF6B1A'
                      : '3px solid transparent',
                  }}
                />
              ))}
            </div>
            <div style={styles.coloresCustomRow}>
              <div>
                <div style={styles.editLabelSmall}>Principal</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <input type="color" value={editColorP}
                    onChange={e => setEditColorP(e.target.value)}
                    style={styles.colorPicker} />
                  <span style={styles.colorHex}>{editColorP}</span>
                </div>
              </div>
              <div>
                <div style={styles.editLabelSmall}>Secundario</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <input type="color" value={editColorS}
                    onChange={e => setEditColorS(e.target.value)}
                    style={styles.colorPicker} />
                  <span style={styles.colorHex}>{editColorS}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Modalidades */}
          <div style={styles.editCampo}>
            <div style={styles.editLabel}>Modalidades</div>
            <div style={styles.modalidadesGrid}>
              {MODALIDADES.map(m => (
                <div
                  key={m.id}
                  onClick={() => toggleEditModalidad(m.id)}
                  style={{
                    ...styles.chipBtn,
                    background: editModalidades.includes(m.id) ? '#FF6B1A' : '#F4F6FA',
                    color:      editModalidades.includes(m.id) ? 'white'   : '#4A5568',
                    border:     `1.5px solid ${editModalidades.includes(m.id) ? '#FF6B1A' : '#E8ECF4'}`,
                  }}
                >
                  {m.label}
                </div>
              ))}
            </div>
          </div>

          {/* Zonas */}
          <div style={styles.editCampo}>
            <div style={styles.editLabel}>Zonas donde juegas</div>
            <div style={styles.zonasGrid}>
              {ZONAS.map(z => (
                <div
                  key={z}
                  onClick={() => toggleEditZona(z)}
                  style={{
                    ...styles.chipBtn,
                    background: editZonas.includes(z) ? '#0D1117' : '#F4F6FA',
                    color:      editZonas.includes(z) ? 'white'   : '#4A5568',
                    border:     `1.5px solid ${editZonas.includes(z) ? '#0D1117' : '#E8ECF4'}`,
                  }}
                >
                  {z}
                </div>
              ))}
            </div>
          </div>

          {/* Grupo WhatsApp */}
          <div style={styles.editCampo}>
            <div style={styles.editLabel}>🟢 Link grupo WhatsApp (opcional)</div>
            <input
              style={styles.editInput}
              placeholder="https://chat.whatsapp.com/xxxxx"
              value={editGrupoWsp}
              onChange={e => setEditGrupoWsp(e.target.value)}
            />
            <div style={{ fontSize: 11, color: '#9BA5B7', marginTop: 4, fontFamily: "'Barlow', sans-serif" }}>
              Pega el link de invitación de tu grupo para convocar jugadores con un solo mensaje.
            </div>
          </div>

          {/* WhatsApp personal del capitán */}
          <div style={styles.editCampo}>
            <div style={styles.editLabel}>📱 Mi WhatsApp *</div>
            <input
              style={styles.editInput}
              placeholder="+56 9 1234 5678"
              value={editCelular}
              onChange={e => setEditCelular(e.target.value)}
            />
            <div style={{ fontSize: 11, color: '#9BA5B7', marginTop: 4, fontFamily: "'Barlow', sans-serif" }}>
              Acá te llegan los avisos de desafíos, recordatorios y pagos.
            </div>
          </div>

          {/* Edad del capitán */}
          <div style={styles.editCampo}>
            <div style={styles.editLabel}>Mi edad</div>
            <input
              style={styles.editInput}
              type="number"
              placeholder="Ej: 28"
              value={editEdad}
              onChange={e => setEditEdad(e.target.value)}
              min="10" max="80"
            />
          </div>

          {errorEdit && <div style={styles.editError}>{errorEdit}</div>}

          <div style={styles.editBotones}>
            <button
              style={styles.btnCancelarEdit}
              onClick={() => { setEditando(false); setErrorEdit(''); }}
            >
              Cancelar
            </button>
            <button
              style={{ ...styles.btnGuardarEdit, opacity: guardandoEdit ? 0.7 : 1 }}
              onClick={handleGuardarEdicion}
              disabled={guardandoEdit}
            >
              {guardandoEdit ? 'Guardando...' : '✓ Guardar cambios'}
            </button>
          </div>
        </div>
      )}

      {/* PANEL EDICIÓN PERFIL PÁDEL/TENIS */}
      {!esFutbol && editandoPerfil && (
        <div style={styles.editPanel}>
          <div style={styles.editPanelTitulo}>Modificar perfil de {deporteActivo === 'padel' ? 'Pádel' : 'Tenis'}</div>
          <div style={styles.editCampo}>
            <div style={styles.editLabel}>Nombre o apodo</div>
            <input style={styles.editInput} value={formPerfil.nombre}
              onChange={e => setFormPerfil(p => ({ ...p, nombre: e.target.value }))} maxLength={40} />
          </div>
          <div style={styles.editCampo}>
            <div style={styles.editLabel}>📱 WhatsApp *</div>
            <input style={styles.editInput} value={formPerfil.celular}
              onChange={e => setFormPerfil(p => ({ ...p, celular: e.target.value }))}
              placeholder="+56 9 1234 5678" />
            <div style={{ fontSize: 11, color: '#9BA5B7', marginTop: 4, fontFamily: "'Barlow', sans-serif" }}>
              Acá te llegan los avisos de desafíos, recordatorios y pagos.
            </div>
          </div>
          <div style={styles.editCampo}>
            <div style={styles.editLabel}>Edad</div>
            <input style={styles.editInput} type="number" value={formPerfil.edad}
              onChange={e => setFormPerfil(p => ({ ...p, edad: e.target.value }))}
              placeholder="Ej: 28" min="10" max="80" />
          </div>
          <div style={styles.editBotones}>
            <button style={styles.btnCancelarEdit} onClick={() => setEditandoPerfil(false)}>Cancelar</button>
            <button style={{ ...styles.btnGuardarEdit, opacity: guardandoPerfil ? 0.7 : 1 }}
              onClick={handleGuardarPerfil} disabled={guardandoPerfil}>
              {guardandoPerfil ? 'Guardando...' : '✓ Guardar cambios'}
            </button>
          </div>
        </div>
      )}

      {/* STATS */}
      <div style={styles.statsGrid}>
        {[
          { n: partidos,                       l: 'Partidos',  color: '#141922' },
          { n: victorias,                      l: 'Victorias', color: '#16A34A' },
          ...(esFutbol ? [{ n: empates, l: 'Empates', color: '#F59E0B' }] : []),
          { n: partidos - victorias - (esFutbol ? empates : 0), l: 'Derrotas', color: '#EF4444' },
        ].map(({ n, l, color }) => (
          <div key={l} style={styles.statCard}>
            <div style={{ ...styles.statNum, color }}>{n}</div>
            <div style={styles.statLabel}>{l}</div>
          </div>
        ))}
      </div>

      {/* COLUMNAS */}
      <div style={styles.cols}>
        <div style={styles.colLeft}>
          <div style={styles.card}>
            <div style={styles.cardTitle}>Próximo partido</div>
            <div style={styles.sinPartido}>
              <div style={styles.sinPartidoIcono}>📅</div>
              <div style={styles.sinPartidoTexto}>No tienes partidos confirmados aún</div>
              <button style={styles.btnBuscar} onClick={() => navigate('/app/matchmaking')}>
                Buscar rival →
              </button>
            </div>
          </div>

          <div style={styles.card}>
            <div style={styles.cardTitle}>Accesos rápidos</div>
            <div style={styles.accesosList}>
              {[
                { icono: '🎯', label: 'Buscar rival',                          ruta: '/app/matchmaking'  },
                { icono: '👥', label: esFutbol ? 'Ver nómina' : 'Mis parejas', ruta: '/app/nomina'       },
                { icono: '📊', label: 'Estadísticas',                          ruta: '/app/estadisticas' },
                { icono: '🏆', label: 'Ver ranking',                           ruta: '/app/ranking'      },
                ...(esFutbol ? [
                  { icono: '🏟️', label: 'Recintos', ruta: '/app/recintos' },
                  { icono: '🟡', label: 'Árbitros',  ruta: '/app/arbitros' },
                ] : []),
              ].map(({ icono, label, ruta }) => (
                <div key={ruta} style={styles.accesoItem} onClick={() => navigate(ruta)}>
                  <span style={styles.accesoIcono}>{icono}</span>
                  <span style={styles.accesoLabel}>{label}</span>
                  <span style={styles.accesoArrow}>→</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div style={styles.colRight}>
          <div style={styles.card}>
            <div style={styles.cardTitleRow}>
              <div style={styles.cardTitle}>Desafíos recibidos</div>
              {desafios.length > 0 && (
                <div style={styles.badgeCount}>{desafios.length}</div>
              )}
            </div>

            {cargando ? (
              <div style={styles.sinDesafios}>Cargando...</div>
            ) : desafios.length === 0 ? (
              <div style={styles.sinDesafios}>No tienes desafíos pendientes</div>
            ) : (
              <div style={styles.desafiosList}>
                {desafios.map(d => {
                  const colores = ['#EF4444','#1A6BFF','#16A34A','#7C3AED','#FF6B1A'];
                  const c1 = colores[d.equipo_local_id % colores.length];
                  const c2 = colores[(d.equipo_local_id + 2) % colores.length];
                  return (
                    <div key={d.id} style={styles.desafioCard}>
                      <div style={styles.desafioHeader}>
                        <div style={{ ...styles.desafioCrest, background: `linear-gradient(135deg, ${c1}, ${c2})` }}>
                          {getNombreEquipo(d.equipo_local_id).split(' ').map(p => p[0]).slice(0,2).join('').toUpperCase()}
                        </div>
                        <div style={styles.desafioInfo}>
                          <div style={styles.desafioRival}>
                            {getNombreEquipo(d.equipo_local_id)}
                          </div>
                          <div style={styles.desafioMeta}>
                            {d.fecha && `📅 ${d.fecha}`}{d.hora && ` · ${d.hora}`}
                          </div>
                        </div>
                      </div>
                      {d.mensaje && (
                        <div style={styles.desafioMensaje}>"{d.mensaje}"</div>
                      )}
                      <div style={styles.desafioBotones}>
                        <button style={styles.btnRechazar} onClick={() => handleRechazar(d.id)}>
                          Rechazar
                        </button>
                        <button style={styles.btnAceptar} onClick={() => handleAceptar(d.id)}>
                          ⚡ Aceptar desafío
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  pagina: { padding: '24px 32px', background: '#F4F6FA', minHeight: '100vh' },
  sinEquipoCard: {
    maxWidth: 480, margin: '80px auto',
    background: 'white', border: '1px solid #E8ECF4',
    borderRadius: 20, padding: '48px 40px', textAlign: 'center',
  },
  sinEquipoIcono: { fontSize: 56, marginBottom: 16 },
  sinEquipoTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 28, fontWeight: 800, color: '#141922', marginBottom: 8,
  },
  sinEquipoSub: {
    fontSize: 14, color: '#9BA5B7',
    fontFamily: "'Barlow', sans-serif",
    lineHeight: 1.6, marginBottom: 24,
    maxWidth: 320, margin: '0 auto 24px',
  },
  btnCrearEquipo: {
    background: '#FF6B1A', color: 'white', border: 'none',
    borderRadius: 12, padding: '14px 28px', cursor: 'pointer',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 18, fontWeight: 800,
  },
  equipoCard: {
    background: '#0D1117', borderRadius: 20, padding: '24px',
    display: 'flex', justifyContent: 'space-between',
    alignItems: 'center', marginBottom: 16,
  },
  equipoLeft: { display: 'flex', alignItems: 'center', gap: 18 },
  escudo: {
    width: 64, height: 64, borderRadius: 16,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 22, fontWeight: 800, color: 'white',
    border: '2px solid rgba(255,255,255,0.15)', flexShrink: 0,
  },
  equipoInfo: {},
  equipoNombre: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 26, fontWeight: 800, color: 'white', marginBottom: 2,
    cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 8,
  },
  editHint: { fontSize: 14, opacity: 0.5 },
  equipoUsuario: {
    fontSize: 12, color: 'rgba(255,255,255,0.5)',
    fontFamily: "'Barlow', sans-serif", marginBottom: 4,
  },
  equipoMeta: {
    fontSize: 13, color: 'rgba(255,255,255,0.4)',
    fontFamily: "'Barlow', sans-serif", marginBottom: 8,
  },
  planBadge: {
    display: 'inline-block',
    background: 'rgba(255,255,255,0.08)',
    color: 'rgba(255,255,255,0.6)',
    fontSize: 11, fontWeight: 700,
    padding: '3px 10px', borderRadius: 20,
    fontFamily: "'Barlow', sans-serif",
  },
  equipoDerecha: {
    display: 'flex', flexDirection: 'column',
    alignItems: 'flex-end', gap: 10,
  },
  eloWrap: { textAlign: 'right' },
  eloNum: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 52, fontWeight: 800, color: 'white', lineHeight: 1,
  },
  eloLabel: {
    fontSize: 11, color: 'rgba(255,255,255,0.3)',
    fontFamily: "'Barlow', sans-serif",
    textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 4,
  },
  eloTendencia: {
    fontSize: 13, color: '#16A34A', fontWeight: 700,
    fontFamily: "'Barlow', sans-serif",
  },
  equipoBotones: {
    display: 'flex', flexDirection: 'column',
    gap: 6, alignItems: 'flex-end',
  },
  btnCambiarEquipo: {
    background: 'rgba(255,255,255,0.1)',
    border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: 8, padding: '5px 12px',
    color: 'white', fontSize: 11,
    cursor: 'pointer', fontFamily: "'Barlow', sans-serif",
  },
  selectorDropdown: {
    position: 'absolute', top: '100%', right: 0, marginTop: 4,
    background: 'white', border: '1px solid #E8ECF4',
    borderRadius: 12, boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
    minWidth: 200, zIndex: 100, overflow: 'hidden',
  },
  selectorItem: {
    display: 'flex', alignItems: 'center', gap: 8,
    padding: '10px 14px', cursor: 'pointer',
    borderBottom: '1px solid #F4F6FA',
  },
  btnOtroEquipo: {
    background: '#FF6B1A', border: 'none',
    borderRadius: 8, padding: '7px 14px',
    color: 'white', fontSize: 12, fontWeight: 700,
    cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif",
  },
  editPanel: {
    background: 'white', border: '1px solid #E8ECF4',
    borderRadius: 16, padding: '24px 28px', marginBottom: 16,
  },
  editPanelTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 18, fontWeight: 800, color: '#141922', marginBottom: 18,
  },
  editCampo: { marginBottom: 18 },
  editLabel: {
    fontSize: 11, fontWeight: 700, color: '#6B7280',
    textTransform: 'uppercase', letterSpacing: '0.05em',
    marginBottom: 8, fontFamily: "'Barlow', sans-serif",
  },
  editLabelSmall: {
    fontSize: 10, fontWeight: 700, color: '#9BA5B7',
    textTransform: 'uppercase', letterSpacing: '0.04em',
    marginBottom: 6, fontFamily: "'Barlow', sans-serif",
  },
  editInput: {
    width: '100%', padding: '11px 14px',
    border: '1.5px solid #E8ECF4', borderRadius: 10,
    fontSize: 14, color: '#141922',
    fontFamily: "'Barlow', sans-serif",
    outline: 'none', boxSizing: 'border-box',
  },
  coloresGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)',
    gap: 8, marginBottom: 12,
  },
  colorPreset: {
    width: '100%', aspectRatio: '1',
    borderRadius: 8, cursor: 'pointer',
  },
  coloresCustomRow: {
    display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14,
  },
  colorPicker: {
    width: 36, height: 36, border: '1.5px solid #E8ECF4',
    borderRadius: 8, cursor: 'pointer', padding: 2,
  },
  colorHex: {
    fontSize: 12, color: '#6B7280',
    fontFamily: "'Barlow', sans-serif", textTransform: 'uppercase',
  },
  modalidadesGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8,
  },
  zonasGrid: { display: 'flex', flexWrap: 'wrap', gap: 8 },
  chipBtn: {
    padding: '8px 14px', borderRadius: 20,
    cursor: 'pointer', fontSize: 12, fontWeight: 600,
    fontFamily: "'Barlow', sans-serif", transition: 'all 0.1s',
    textAlign: 'center',
  },
  editError: {
    color: '#EF4444', fontSize: 12,
    fontFamily: "'Barlow', sans-serif", marginBottom: 12,
  },
  editBotones: {
    display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 10, marginTop: 4,
  },
  btnCancelarEdit: {
    padding: '11px', background: 'white',
    border: '1.5px solid #E8ECF4', borderRadius: 10,
    fontSize: 14, fontWeight: 700, color: '#6B7280',
    cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif",
  },
  btnGuardarEdit: {
    padding: '11px', background: '#FF6B1A', border: 'none',
    borderRadius: 10, fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 15, fontWeight: 800, color: 'white', cursor: 'pointer',
  },
  statsGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 12, marginBottom: 20,
  },
  statCard: {
    background: 'white', border: '1px solid #E8ECF4',
    borderRadius: 14, padding: '16px', textAlign: 'center',
  },
  statNum: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 30, fontWeight: 800, lineHeight: 1, marginBottom: 4,
  },
  statLabel: {
    fontSize: 10, color: '#9BA5B7',
    fontFamily: "'Barlow', sans-serif",
    textTransform: 'uppercase', letterSpacing: '0.05em',
  },
  cols: {
    display: 'grid', gridTemplateColumns: '1fr 1fr',
    gap: 16, alignItems: 'start',
  },
  colLeft:  { display: 'flex', flexDirection: 'column', gap: 16 },
  colRight: { display: 'flex', flexDirection: 'column', gap: 16 },
  card: {
    background: 'white', border: '1px solid #E8ECF4',
    borderRadius: 16, padding: '20px',
  },
  cardTitle: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 13, fontWeight: 700, color: '#9BA5B7',
    textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 14,
  },
  cardTitleRow: {
    display: 'flex', alignItems: 'center',
    justifyContent: 'space-between', marginBottom: 14,
  },
  badgeCount: {
    background: '#FF6B1A', color: 'white',
    fontSize: 11, fontWeight: 700,
    padding: '2px 8px', borderRadius: 20,
    fontFamily: "'Barlow', sans-serif",
  },
  sinPartido: { textAlign: 'center', padding: '20px 0' },
  sinPartidoIcono: { fontSize: 32, marginBottom: 8 },
  sinPartidoTexto: {
    fontSize: 13, color: '#9BA5B7',
    fontFamily: "'Barlow', sans-serif", marginBottom: 14,
  },
  btnBuscar: {
    background: '#FF6B1A', color: 'white', border: 'none',
    borderRadius: 10, padding: '10px 20px', cursor: 'pointer',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 14, fontWeight: 700,
  },
  sinDesafios: {
    fontSize: 13, color: '#9BA5B7',
    fontFamily: "'Barlow', sans-serif",
    textAlign: 'center', padding: '20px 0',
  },
  desafiosList: { display: 'flex', flexDirection: 'column', gap: 14 },
  desafioCard: { background: '#F4F6FA', borderRadius: 12, padding: '14px' },
  desafioHeader: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 },
  desafioCrest: {
    width: 38, height: 38, borderRadius: 9, flexShrink: 0,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 11, fontWeight: 800, color: 'white',
  },
  desafioInfo: { flex: 1 },
  desafioRival: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 15, fontWeight: 800, color: '#141922', marginBottom: 2,
  },
  desafioMeta: {
    fontSize: 11, color: '#9BA5B7',
    fontFamily: "'Barlow', sans-serif",
  },
  desafioMensaje: {
    fontSize: 11, color: '#6B7280',
    fontFamily: "'Barlow', sans-serif",
    fontStyle: 'italic', marginBottom: 10, lineHeight: 1.4,
  },
  desafioBotones: { display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 8 },
  btnRechazar: {
    padding: '9px', background: 'white',
    border: '1.5px solid #E8ECF4', borderRadius: 9,
    fontSize: 12, fontWeight: 700, color: '#6B7280',
    cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif",
  },
  btnAceptar: {
    padding: '9px', background: '#FF6B1A', border: 'none',
    borderRadius: 9, fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 13, fontWeight: 800, color: 'white', cursor: 'pointer',
  },
  accesosList: { display: 'flex', flexDirection: 'column', gap: 4 },
  accesoItem: {
    display: 'flex', alignItems: 'center', gap: 10,
    padding: '10px 8px', borderRadius: 9,
    cursor: 'pointer', transition: 'background 0.12s',
  },
  accesoIcono: { fontSize: 18, flexShrink: 0 },
  accesoLabel: {
    flex: 1, fontSize: 13, fontWeight: 600,
    color: '#141922', fontFamily: "'Barlow', sans-serif",
  },
  accesoArrow: { fontSize: 14, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" },
  deporteSelector: {
    display: 'flex', gap: 8, marginBottom: 12,
  },
  deporteTab: {
    padding: '8px 18px', borderRadius: 20, cursor: 'pointer',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 14, fontWeight: 700, transition: 'all 0.12s',
    display: 'flex', alignItems: 'center', gap: 6, position: 'relative',
  },
  deporteDot: {
    width: 6, height: 6, borderRadius: '50%',
    background: '#16A34A', flexShrink: 0,
  },
  btnEliminarPerfil: {
    background: 'transparent',
    border: '1px solid rgba(239,68,68,0.4)',
    borderRadius: 8, padding: '7px 14px',
    color: '#EF4444', fontSize: 12, fontWeight: 700,
    cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif",
  },
};
